// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"Z2","sticky_header_title":"a3","stycky_header_title_mob":"b3","root_scroller":"c3","scroller":"e3","indicator":"f3","scrollButtons":"g3","selected":"h3","root_tab_scrollable":"i3","root_scroller_mob":"j3","scroller_mob":"k3","indicator_mob":"l3","selected_mob":"m3","root_tab_mob":"n3","root_tab_mob_scrollable":"o3","sticky_header_title_mob":"p3"};
    if(module.hot) {
      // 1730991512260
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  